module.exports = __webpack_public_path__ + "static/media/ic_name_danger.a56df0e0.svg";